import { ArticleType, ArticleTypeExternal } from '@nemuru-eng/js-api-client';

import { Accommodation } from '@/components/shared/components/ItemDetail/components/Accommodation';
import { Automobile } from '@/components/shared/components/ItemDetail/components/Automobile';
import { Flight } from '@/components/shared/components/ItemDetail/components/Flight';
import { OnlineProduct } from '@/components/shared/components/ItemDetail/components/OnlineProduct';
import { Service } from '@/components/shared/components/ItemDetail/components/Service';
import { Travel } from '@/components/shared/components/ItemDetail/components/Travel';
import { ItemDetailProps } from '@/components/shared/components/ItemDetail/types/ItemDetailProps';

export const ItemDetail = ({ itemDetail, itemStatus, currency }: ItemDetailProps) => {
  switch (itemDetail.article.type as ArticleType | ArticleTypeExternal) {
    case ArticleTypeExternal.FLIGHT:
      return <Flight itemDetail={itemDetail} currency={currency} itemStatus={itemStatus} />;
    case ArticleTypeExternal.PRODUCT:
    case ArticleType.ONLINE_PRODUCT:
      return <OnlineProduct itemDetail={itemDetail} itemStatus={itemStatus} currency={currency} />;
    case ArticleTypeExternal.ACCOMMODATION:
      return <Accommodation itemDetail={itemDetail} itemStatus={itemStatus} currency={currency} />;
    case ArticleTypeExternal.SERVICE:
      return <Service itemDetail={itemDetail} itemStatus={itemStatus} currency={currency} />;
    case ArticleTypeExternal.TRAVEL:
      return <Travel itemDetail={itemDetail} itemStatus={itemStatus} currency={currency} />;
    case ArticleTypeExternal.AUTOMOBILE:
      return <Automobile itemDetail={itemDetail} itemStatus={itemStatus} currency={currency} />;
    default:
      return null;
  }
};
